import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "event-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_ctx.row.isSystemEvent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "event-actions__item",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEdit && _ctx.onEdit(...args)), ["stop"]))
        }, [
          _createVNode(_component_IconComponent, { name: "edit" })
        ]),
        _createElementVNode("div", {
          class: "event-actions__item",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)), ["stop"]))
        }, [
          _createVNode(_component_IconComponent, { name: "delete-not-fill" })
        ])
      ]))
    : _createCommentVNode("", true)
}